<template>
	<div class="btn-set">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'ButtonSet'
};
</script>

<style lang="scss" scoped>
.btn-set {
	display: inline-flex;

	> *:not(:last-child) {
		margin-right: $gutter-lg;

		@include mq($until: lg) {
			&:not(:last-child) {
				margin-right: $gutter-xl;
			}
		}
	}
}
</style>
